import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { useCheckUserPermission } from "../../../../api/hooks/useCheckUserPermission";
import CustomToolTipWithPermission from "../../../../components/CustomToolTipWithPermission";
import { PLATFORM_USER_ACTIONS } from "../../../../utils/constants";

// TODO future work: https://linear.app/breeze-security/issue/DEV-2895/add-expiry-to-api-keys
const expiryOptions = [
  { label: "1 week", value: 7 },
  { label: "1 month", value: 30 },
  { label: "6 months", value: 180 },
  { label: "1 year", value: 365 },
];

const ExternalAPIKeyCreationModal = ({
  open,
  handleClose,
  handleGenerateAPIKey,
}) => {
  const [keyName, setKeyName] = useState("");
  const [expiryDays, setExpiryDays] = useState(expiryOptions[0].value);

  const { permitted: hasPermission } = useCheckUserPermission(
    PLATFORM_USER_ACTIONS.GENERATE_API_KEY
  );

  const handleSubmit = () => {
    handleGenerateAPIKey(keyName, expiryDays);
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Create new API Key</DialogTitle>
      <DialogContent>
        <Box component="form" sx={{ mt: 2 }}>
          <TextField
            fullWidth
            label="Key Name"
            value={keyName}
            onChange={(e) => setKeyName(e.target.value)}
            margin="normal"
          />
          {/* TODO future work: https://linear.app/breeze-security/issue/DEV-2895/add-expiry-to-api-keys */}
          {/* <Select
            fullWidth
            value={expiryDays}
            onChange={(e) => setExpiryDays(e.target.value)}
            margin="normal"
          >
            {expiryOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select> */}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <CustomToolTipWithPermission
          title={null}
          permission={hasPermission}
          placement="bottom"
        >
          <span>
            <Button
              onClick={handleSubmit}
              color="primary"
              variant="contained"
              disabled={!hasPermission}
            >
              Generate
            </Button>
          </span>
        </CustomToolTipWithPermission>
      </DialogActions>
    </Dialog>
  );
};

export default ExternalAPIKeyCreationModal;
